"use strict";
////////////////////////////////////////////////
// Model
////////////////////////////////////////////////
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewUsersChartSettingsJSONModel = void 0;
class NewUsersChartSettingsJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetCumulativeGrowthPercent();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            this.cumulativeGrowthPercent = validateCumulativeGrowthPercent(serializedState === null || serializedState === void 0 ? void 0 : serializedState.cumulativeGrowthPercent);
        };
        this.serialize = () => {
            return {
                cumulativeGrowthPercent: this.cumulativeGrowthPercent
            };
        };
        ////////////////////////////////////////////////
        // CumulativeGrowthPercent
        ////////////////////////////////////////////////
        this.getCumulativeGrowthPercent = () => this.cumulativeGrowthPercent;
        this.setCumulativeGrowthPercent = (value) => this.cumulativeGrowthPercent = validateCumulativeGrowthPercent(value);
        this.resetCumulativeGrowthPercent = () => this.setCumulativeGrowthPercent(false);
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.NewUsersChartSettingsJSONModel = NewUsersChartSettingsJSONModel;
const validateCumulativeGrowthPercent = (value) => {
    return value === true;
};
